import { ArticleWrapper } from "@orlandohealth/build-kit";
import type { BasePageProps } from "@orlandohealth/build-kit";
import { ContentHubSearch } from "@orlandohealth/build-kit";
import type { GetStaticProps } from "next";
import { SectionPage } from "@orlandohealth/build-kit";
import builder from "@builder.io/react";

// ArticleWrapper expects BasePageProps, but for the search index page we only need layout (header/footer)
const ContentHubSearchPage = () => (
    <ArticleWrapper url="/content-hub/search" siteProperties={{}}>
        <ContentHubSearch />
    </ArticleWrapper>
);

export const getStaticProps: GetStaticProps<BasePageProps> = async ({
    params,
    locale,
    defaultLocale,
}) => {
    const urlPath = `/content-hub/search`;
    const _slug = (params?.slug as string[])?.[0];

    const baseProps = await SectionPage.getStaticProps(
        urlPath,
        _slug,
        locale,
        defaultLocale
    );
    // Get alerts based on the article's targeting scope
    const globalAlerts = await builder.getAll("alert", {
        userAttributes: {
            scope: "global",
        },
    });

    const alerts = [...globalAlerts];

    const currentUrl = `/content-hub/${(params?.slug as string[])?.join("/") || ""}`;

    // Get CTAs based on the article's targeting scope
    const globalCTAs = await builder.getAll("cta", {
        userAttributes: {
            scope: "global",
            urlPath: currentUrl,
        },
    });

    const ctas = [...globalCTAs];

    return {
        props: {
            ...baseProps.props,
            alerts: alerts || [],
            ctas: ctas || [],
        },
    };
};

export default ContentHubSearchPage; 